module.exports = __webpack_public_path__ + "img/email-black.83377c33.svg";